<template>
  <div id="contenedor-main-listado-pagos">
    <desktop
      :listado="listado">
    </desktop>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoPagos',
  components: {
    Desktop,
  },
  props: {
    listado: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
